import {RESET_DOCUMENTS} from 'constants/actionTypes'
import type {RootAction} from 'reducers'

export function resetDocumentsState(): RootAction {
  return {
    type: RESET_DOCUMENTS
  }
}
